<template>
	<div class='textArea'>
		<textarea v-bind:style="{ height: height }" v-bind:value="value" @input='input($event.target.value)'> 
		</textarea>
		<span v-if='value == ""'>{{hitMsg}}</span>
	</div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
	props: {
		//绑定值
		value: {
			type: String,
			default: ""
		},
		//高度
		height: {
			type: String,
			default: ""
		},
		//提示信息
		hitMsg: {
			type: String,
			default: ""
		}
  },
	methods: {
		input(val){
			this.$emit('input', val)
		}
	},
	computed: {
		showHint(){
			return true
		}
	}
}
</script>

<style lang="less" scoped>
	@import "../../assets/theme.less";
	.textArea{
		position: relative;
		font-size:0.28rem;
		textarea{
			display:block;
			width:100%;
			height:100%;
			margin:0 auto;
			padding:10px;
			outline:none;
			border:none;
			background-color:#f6f6f6;
			border:1px solid #eeeeee;
		}
		span{
			width:100%;
			position:absolute;
			top:10px;
			left: 10px;
			z-index:999;
			color:#cccccc;
			//击穿顶层
			pointer-events:none;
		}
	}
</style>


// WEBPACK FOOTER //
// inputArea.vue?826d893e